import $ from "jquery";
import "slick-carousel";

function initSolutionsCustomerSlider() {
  if ($(".js-solutions-customer-slider").length) {
    const slider = $(".js-solutions-customer-slider");

    slider.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: false,
      nextArrow:
        '<button type="button" class="slick-next"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M13.9931 12L8.45277 5.42079L9.60015 4.45459L15.9541 12L9.60015 19.5454L8.45277 18.5792L13.9931 12Z" fill="white"/></svg></button>',
      prevArrow:
        '<button type="button" class="slick-prev"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M10.0069 12L15.5472 5.42079L14.3999 4.45459L8.0459 12L14.3999 19.5454L15.5472 18.5792L10.0069 12Z" fill="white"/></svg></button>',
    });
  }
}

function destroySolutionsCustomerSlider() {
  if ($(".js-solutions-customer-slider").length) {
    $(".js-solutions-customer-slider").slick("destroy");
  }
}

document.addEventListener("DOMContentLoaded", () => {
  const links = document.querySelectorAll(
    ".solutions-customer__top-links__link"
  );
  const cards = document.querySelectorAll(".solutions-customer__card");

  // Function to update active states and show/hide cards
  const updateActiveCard = (clickedLink) => {
    // Remove active class from all links and add to clicked one
    links.forEach((link) => link.classList.remove("active"));
    clickedLink.classList.add("active");

    // Get the card ID from the clicked link
    const targetCardId = clickedLink.getAttribute("cardid");

    // Show/hide cards based on ID
    cards.forEach((card) => {
      if (card.getAttribute("cardid") === targetCardId) {
        card.style.display = "block";
        card.classList.add("active");
      } else {
        card.style.display = "none";
        card.classList.remove("active");
      }
    });

    // Update the slider
    destroySolutionsCustomerSlider();
    initSolutionsCustomerSlider();
  };

  // Add click event listeners to all links
  links.forEach((link) => {
    link.addEventListener("click", (e) => {
      e.preventDefault(); // Prevent default link behavior
      updateActiveCard(link);
    });
  });

  initSolutionsCustomerSlider();
});
